import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { RootState } from "../../app/store"
import { fetchOpenPositions } from "./openPositionsAPI"

export interface OpenPositionItem {
  title: string
  id: string
  slug: string
  company: string
  style: string
  location: string
  nation: string
  region: string
  county: string
  county_code: string
  city: string
  lat: string
  lng: string
  published: string
  expires: string
  location_label: string
  expires_label: string
  url: string
  popupname?: string
  industry: string
  function: string
  seniority_level: string
  contract_type: string
  contract_duration?: any
  years_of_experience: string
  remote_working: string
  description: string
  other_information_description: string
  vacancy_owner: string
  registration_iframe_url: string
  bold: string
  highlighted: string
  logo: string
  coverImage?: any
  ref_code?: any
  project?: any
  project_label?: any
  last_update: string
  team_id: string
  team: string
  external_registration_link?: any
  tags?: any
  company_description: string
  position_description: string
  requirements_description: string
}

export const STATUS_IDLE = "idle"
export const STATUS_LOADING = "loading"
export const STATUS_FAILED = "failed"

export interface OpenPositionState {
  items: Array<OpenPositionItem>
  status: typeof STATUS_IDLE | typeof STATUS_LOADING | typeof STATUS_FAILED
}

const initialState: OpenPositionState = {
  items: [],
  status: STATUS_IDLE,
}

export const fetchOpenPositionsAsync = createAsyncThunk(
  "counter/fetchOpenPositions",
  async (endopoint: string) => {
    const response = await fetchOpenPositions(endopoint)
    // The value we return becomes the `fulfilled` action payload
    return response.data
  },
)

export const openPositionsSlice = createSlice({
  name: "openPositions",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setOpenPositions: (state, action) => {
      state = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpenPositionsAsync.pending, (state) => {
        state.status = STATUS_LOADING
      })
      .addCase(fetchOpenPositionsAsync.fulfilled, (state, action) => {
        state.status = STATUS_IDLE
        state.items = action.payload
      })
      .addCase(fetchOpenPositionsAsync.rejected, (state) => {
        state.status = STATUS_FAILED
      })
  },
})

export const { setOpenPositions } = openPositionsSlice.actions

export const selectOpenPositions = (state: RootState) =>
  state.openPositions.items
export const selectOpenPositionsStatus = (state: RootState) =>
  state.openPositions.status

export default openPositionsSlice.reducer
